//fire
import "../row3.css"

function Row3(props) {
  return (
    <div className="row3container">
      <div id="row3-1" className="row3">
      <img 
      src="https://preview.redd.it/01hdto0hzcn51.jpg?width=1846&format=pjpg&auto=webp&s=a20c4243466f1849aa29432a31310eb7628c0ba4"
      />
      <h4>Purchase the New Xbox Series X!</h4>
      </div>
    </div>
  )
}

export default Row3;
